module.exports = __webpack_public_path__ + "img/sys5.4d60f785.png";